import { render, staticRenderFns } from "./records_no_code.vue?vue&type=template&id=3beaf99e&scoped=true"
import script from "./records_no_code.vue?vue&type=script&lang=js"
export * from "./records_no_code.vue?vue&type=script&lang=js"
import style0 from "./records_no_code.vue?vue&type=style&index=0&id=3beaf99e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3beaf99e",
  null
  
)

export default component.exports